/**
 * @legacy
 * @prev website/templates/website/domains.html
 */
import './css/domain_style_desktop.css'
import './css/domain_style_responsive.css'

/**
 * @legacy
 * @prev website/static/js/domain_index.js
 */
$(function() {
    const tabs = document.querySelectorAll('.container-tab .tab');
    const indexes = document.querySelectorAll('.wrapper-content-tab .acr');
    const items = document.querySelectorAll('.wrapper-content-tab .tab .el');
    const tabList = document.querySelector('.li-al');

    const route = () => {
      const hash = window.location.hash

      updateTabs(hash)
      updateTitle(hash)
      updateList(hash)
    }

    const updateTabs = (hash) => {
      tabs.forEach(tab => {
        if (tab.getAttribute('href') === hash) {
          tab.classList.add('select');
        } else {
          tab.classList.remove('select');
        }
      })
    }

    const updateList = (hash) => {
      let query = '';

      if (hash === '#main') {
        let mainArray = [];

        for (const item of items) {
          if (!item.classList.contains('main')) {
            item.classList.add('el-hidden');
          } else {
            item.classList.remove('el-hidden');
            // Get the first letter of the main TLD
            const parentClass = item.parentNode.classList;
            mainArray.push(`.acr[href="#${parentClass[parentClass.length-1].slice(-1)}"]`);
          }
        }
        // Filter duplicates in the main TLDs collection
        const uniqueMain = [...new Set(mainArray)];
        query = uniqueMain.toString();
        tabList.className = 'li-al';
      } else if (hash.length === 2) {
        for (const item of items) {
          if (!item.parentNode.classList.contains(`li-el-${hash[1]}`)) {
            item.classList.add('el-hidden');
          } else {
            item.classList.remove('el-hidden');
          }
        }
        query = `.acr[href="${hash}"]`;
        tabList.className = `li-al acr-${hash[1].toUpperCase()}`;
      } else {
        for (const item of items) {
          item.classList.remove('el-hidden');
        }
        query = '.acr';
        tabList.className = 'li-al';
      }

      const filter = document.querySelectorAll(query);
      updateIdx(filter);
    }

    const updateTitle = (hash) => {
      const heading = document.querySelector('.wrapper-content-tab h3');
      const source = document.querySelector(`[href="${hash}"]`);
      const text = source.getAttribute('aria-label') ? source.getAttribute('aria-label') : source.textContent;
      heading.textContent = text;
    }

    const updateIdx = (filter) => {
      const filtered = new Set(filter);
      for (const el of indexes) {
        el.classList.toggle('transparent', !filtered.has(el));
      }
    }

    if ('onhashchange' in window) {
        window.addEventListener('hashchange', route, false)
    }

    if (!window.location.hash) {
      window.location.hash = '#main'
    } else {
      route()
    }

    /*==================================
    =          DETAILS MODAL           =
    ==================================*/
    const details = document.querySelectorAll('.details');
    const backdrop = document.getElementById('black_fog');

    details.forEach(el => {
      el.addEventListener('click', openModal);
    });

    function openModal(event) {
      const closeBtn = document.querySelector(`.domain_popup[data-id="${event.target.id}"] .cross`);
      const modal = document.querySelector(`.domain_popup[data-id="${event.target.id}"]`);
      const modalComputedStyle = window.getComputedStyle(modal, null);
      const modalHeight =
        modal.clientHeight -
        parseFloat(modalComputedStyle.paddingTop) -
        parseFloat(modalComputedStyle.paddingBottom) +
        closeBtn.clientHeight;

      event.stopPropagation();

      if (modalHeight < window.innerHeight) {
        const position = window.scrollY + ((window.innerHeight - modalHeight) / 2);
        modal.style.top = `${position}px`;
      } else {
        modal.style.top = `${window.scrollY + 40}px`;
      }

      backdrop.classList.add('shown');
      modal.classList.add('shown');
      backdrop.addEventListener('click', closeModal);
      closeBtn.addEventListener('click', closeModal);
    }

    function closeModal() {
      const modal = document.querySelector('.domain_popup.shown');
      const closeBtn = document.querySelector('.domain_popup.shown .cross');

      backdrop.classList.remove('shown');
      modal.classList.remove('shown');
      backdrop.removeEventListener('click', closeModal);
      closeBtn.removeEventListener('click', closeModal);
    }

    /*==================================
    =            RESPONSIVE            =
    ==================================*/
    const rsmContent = document.querySelector('.content-rsm');
    const tabContainer = document.querySelector('.container-tab');
    const tabContent = document.querySelector('.wrapper-content-tab');

    if (window.matchMedia("(max-width: 700px)").matches) {
      tabContent.after(rsmContent);
    }
    if (window.matchMedia("(min-width: 701px)").matches) {
      tabContainer.after(rsmContent);
    }
})
